import { getTimeout } from '@/helpers/globals.ts'

export async function delay(time: number): Promise<void> {
    const { setTimeout } = getTimeout() ?? { setTimeout: undefined }

    if (setTimeout) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, time)
        })
    }

    return Promise.resolve()
}

export async function delayData<T>(
    data: T | PromiseLike<T>,
    time: number
): Promise<T> {
    const { setTimeout } = getTimeout() ?? { setTimeout: undefined }

    if (setTimeout) {
        return new Promise((resolve) => {
            return setTimeout(() => {
                resolve(data)
            }, time)
        })
    }

    return Promise.resolve(data)
}
